import classNames from 'classnames';

import styles from '../../styles/icons/loading-icon.module.css';

interface LoadingIconProps {
    loading?: boolean;
    className?: string;
}

function LoadingIcon({ loading = true, className = null }: LoadingIconProps) {
    return (
        <span
            className={classNames([
                'material-symbols-rounded',
                styles.container,
                {
                    [styles.loading]: loading,
                },
                className,
            ])}
        >
            progress_activity
        </span>
    );
}

export default LoadingIcon;
